import { render, staticRenderFns } from "./PortfolioSix.vue?vue&type=template&id=70a1c658"
import script from "./PortfolioSix.vue?vue&type=script&lang=js"
export * from "./PortfolioSix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports